
import AdminEditComponent from "../../../components/admins/Edit.vue";

export default {
  components: {
    AdminEditComponent,
  },
};
